<template>
  <div class="m-0 dbozone-font bg-dinogems" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-dinogems">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -dinogems`">{{ $t('3_5_bonus_20.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4 nav-special-symbols">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_10.png`)"
          alt="">
        </div>
        <div class="col-9 align-items-center p-0 d-flex ml-2 justify-content-center">
          <span class="font-weight-bold text-sub" :class="`-${lang} -wild`">
            {{$t('dinogems.multiplier-desc')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_9.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{$t('dinogems.scatter-desc')}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_8.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{$t('dinogems.symbol-wild')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_7.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[7][4]}}<br>
            {{'4 - ' + paytable[7][3]}}<br>
            {{'3 - ' + paytable[7][2]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_6.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[6][4]}}<br>
            {{'4 - ' + paytable[6][3]}}<br>
            {{'3 - ' + paytable[6][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_5.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[5][4]}}<br>
            {{'4 - ' + paytable[5][3]}}<br>
            {{'3 - ' + paytable[5][2]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[4][4]}}<br>
            {{'4 - ' + paytable[4][3]}}<br>
            {{'3 - ' + paytable[4][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[3][4]}}<br>
            {{'4 - ' + paytable[3][3]}}<br>
            {{'3 - ' + paytable[3][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[2][4]}}<br>
            {{'4 - ' + paytable[2][3]}}<br>
            {{'3 - ' + paytable[2][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-left d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[1][4]}}<br>
            {{'4 - ' + paytable[1][3]}}<br>
            {{'3 - ' + paytable[1][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/dinogems/symbol_0.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[0][4]}}
            <br>{{'4 - ' + paytable[0][3]}}
            <br>{{'3 - ' + paytable[0][2]}}
          </span>
        </div>
      </div>

      <div class="d-flex flex-column nav-dinogems mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -dinogems`">{{ $t('dinogems.respin.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('dinogems.respin.desc') }}</li></span>
      </div>
      <div class="d-flex flex-column nav-dinogems mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -dinogems`">{{ $t('dinogems.respin-feature.title') }}</h5>
        </section>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/dinogems/bonus_respin_feature.png`)" alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('dinogems.respin-feature.desc1') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('dinogems.respin-feature.desc2') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('dinogems.respin-feature.desc3') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('dinogems.respin-feature.desc4') }}</li></span>
      </div>
      <div class="d-flex flex-column nav-dinogems mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -dinogems`">{{ $t('dinogems.freespin.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('dinogems.freespin.desc') }}</li></span>
      </div>

      <!-- todo Custom component -->

      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class="combo">{{ `4 combo`  }}</span>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`7`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x1`}}</div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`5`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x3`}}</div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`3`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x5`}}</div>
      </div>
      <div><hr class="hr-freespin-dinogems" /></div>
      <div class="justify-content-center d-flex flex-row">
        <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/dinogems/combo_4.png`)" alt="">
      </div>

      <!-- todo Custom component -->

      <!-- todo Custom component -->

      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class="combo">{{ `5 combo`  }}</span>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`9`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x1`}}</div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`7`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x3`}}</div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`5`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x5`}}</div>
      </div>
      <div><hr class="hr-freespin-dinogems" /></div>
      <div class="justify-content-center d-flex flex-row">
        <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/dinogems/combo_5.png`)" alt="">
      </div>

      <!-- todo Custom component -->

      <!-- todo Custom component -->

      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class="combo">{{ `6 combo`  }}</span>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`11`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x1`}}</div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`9`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x3`}}</div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`7`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x5`}}</div>
      </div>
      <div><hr class="hr-freespin-dinogems" /></div>
      <div class="justify-content-center d-flex flex-row">
        <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/dinogems/combo_6.png`)" alt="">
      </div>

      <!-- todo Custom component -->

      <!-- todo Custom component -->

      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class="combo">{{ `7 combo`  }}</span>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`13`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x1`}}</div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`11`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x3`}}</div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="white">{{$t('dinogems.freespin.freespin')}}</div>
        <div class="yellow pl-1">{{`9`}}</div>
        <div class="white pl-1">{{$t('dinogems.freespin.multiplier')}}</div>
        <div class="yellow pl-1">{{`x5`}}</div>
      </div>
      <div><hr class="hr-freespin-dinogems" /></div>
      <div class="justify-content-center d-flex flex-row">
        <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/dinogems/combo_7.png`)" alt="">
      </div>

      <!-- todo Custom component -->

      <div class="d-flex flex-column nav-dinogems mt-4 mb-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -dinogems`">{{ $t('dinogems.way.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('dinogems.way.desc1') }}</li></span>
      </div>
      <div class="justify-content-center d-flex flex-col">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/dinogems/line_paytable.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('dinogems.way.desc2') }}</li></span>
      </div>
      <div class="d-flex flex-col p-2 mb-1 justify-content-center">
        <span class="m-0  text-sub">{{ $t('dinogems.way.from-above-example') }}</span>
      </div>
      <div class="d-flex p-2 mb-1 justify-content-center">
        <span class="m-0  text-sub text-sub-yellow">{{ $t('dinogems.way.from-above-example-desc') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('dinogems.way.desc3') }}</li></span>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 mt-2">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/dinogems/way.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">
            {{$t('dinogems.way.win5')}} <br>
            {{$t('dinogems.way.win4')}} <br>
            {{$t('dinogems.way.win3')}}
          </span>
        </div>
        <div class="d-flex flex-column">
          <div class="p-0 justify-content-center d-flex">
            <span class="m-0 text-sub text-sub-gov justify-content-center">{{ $t('dinogems.way.total-winning') }}</span>
          </div>
          <div class="p-0 justify-content-center d-flex">
            <span class="m-0 text-sub text-sub-yellow justify-content-center">{{ $t('dinogems.way.total-winning-desc') }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('dinogems.way.desc4') }}</li></span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('dinogems.way.desc5') }}</li></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-dinogems',
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.icon-paytable {
  width: 100%;
}

.nav-special-symbols {
  border-color: #C0151D;
  border-style: solid;
  border-radius: 15px;
  border-width: thick;
}

.nav-dinogems {
  background: #C0151D;
  border-radius: 10px;
}

.desc-text {
  font-size: 42px;
  color: #fff;
}

.content {
  background: #000013;
  height: 100%;
  width: 100%;
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.span {
  text-align: justify;
  text-justify: inner-word;
}

.text-sub-yellow {
  color: #FFE600;
}

.text-sub-gov {
  text-align: center;
}

.text-sub.-wild {
  text-align: center;
}

.img-infinity {
  width: 100%;
}

.combo {
  font-size: 50px;
  color: #FFBD00;
  font-weight: bold;
}

.white {
  color: #fff;
  font-size: 30px;
}

.yellow {
  color: #FFBD00;
  font-size: 30px;
}

.hr-freespin-dinogems {
  border: 2px solid #C0151D;
  border-radius: 5px;
  margin-top: 0vw;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}

</style>